module.exports = __webpack_public_path__ + "static/media/sym.657e054a.png";